export default __webpack_public_path__ + "static/media/displacement.6fce74f6.svg";